import React from 'react';
import { observer } from 'mobx-react';
import { BannerNoticeStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class BannerNoticeCreate extends React.Component {

  onCreate = title => {
    BannerNoticeStore.create({data: {title, siteId: AppUI.site.id}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a title'
        onCreate={this.onCreate}
      />
    );
  }
}

export default BannerNoticeCreate;
